import React, { FC, Suspense } from 'react';
import moment from 'moment';
import { ExternalLink, Alert } from '@td-client-frontend/icons';
import { ButtonWithIconAndLoader, PageSpinner } from '@td-client-frontend/common';
import { useSSOToEngagementCenter } from '../../hooks/useSSOToEngagementCenter';
import { useLocation } from 'react-router-dom';

export enum MarketingResponseStatus {
  RESTRICTED = 'restricted',
  ERROR = 'error',
  SUCCESS = 'success'
}

const responseType: any = {
  [MarketingResponseStatus.SUCCESS]: {
    title: 'Login'
  },
  [MarketingResponseStatus.RESTRICTED]: {
    title: 'Register'
  },
  [MarketingResponseStatus.ERROR]: {
    title: 'Retry login'
  }
};

const SSOErrorMessage: FC = () => {
  return (
    <>
      <Alert className="mr-3 mt-2" fill="#C9311A" width={32} height={28} />
      <p className="font-effra text-black-default text-lg">
        Oops! We have experienced an unexpected error.
        <br /> Please try again in a bit, our technology team has been notified of the issue.
        <br /> <span className="text-base text-gray-55">{moment().format('LLL')}</span>
      </p>
    </>
  );
};

const SSONotFoundMessage: FC = () => (
  <p className="font-effra text-black-default text-lg">
    Register to gain access. Your account will be active in 1-2 business days following registration.
  </p>
);

const EngagementCenterContent: FC = () => {
  const location = useLocation();

  const { data, isFetching, refetch } = useSSOToEngagementCenter({ trackId: location.key });
  const marketingConfig = { ...responseType[data.status], ...data };
  const { status, title, userId, key } = marketingConfig;

  const onClickHandler = () => {
    switch (status) {
      case MarketingResponseStatus.SUCCESS:
        window.open(`https://engagementcenter.com/Members/UseSSOKey/${userId}?key=${key}`);
        refetch();
        break;
      case MarketingResponseStatus.RESTRICTED:
        window.open('https://engagementcenter.com/register');
        break;
      case MarketingResponseStatus.ERROR:
        refetch();
        break;
    }
  };

  return (
    <div className="flex flex-col justify-center mt-7 space-y-7" data-testid="engagement-center-content">
      {status !== MarketingResponseStatus.SUCCESS && (
        <div className="flex">
          {status === MarketingResponseStatus.ERROR && <SSOErrorMessage />}
          {status === MarketingResponseStatus.RESTRICTED && <SSONotFoundMessage />}
        </div>
      )}
      <ButtonWithIconAndLoader
        onClick={onClickHandler}
        title={title}
        icon={<ExternalLink fill="white" width={16} height={16} />}
        loading={status !== MarketingResponseStatus.RESTRICTED && isFetching}
      />
      {status !== MarketingResponseStatus.RESTRICTED && (
        <a className="text-lg text-blue-80" href="https://engagementcenter.com/Login" target="_blank" rel="noreferrer">
          Log in manually
        </a>
      )}
    </div>
  );
};

const EngagementCenterContentWithSuspense = () => {
  return (
    <Suspense fallback={<PageSpinner size={80} />}>
      <EngagementCenterContent />
    </Suspense>
  );
};

export default EngagementCenterContentWithSuspense;
